import { Alert, Snackbar } from '@mui/material';
import { createContext, type ReactNode, useCallback, useContext, useState } from 'react';

type Severity = 'success' | 'info' | 'warning' | 'error';
type Notify = (message: string, severity?: Severity) => void;

const SnackbarContext = createContext<Notify>(() => undefined);

export function SnackbarProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<{ open: boolean; message: string; severity: Severity; key: number }>({
    open: false,
    message: '',
    severity: 'success',
    key: 0,
  });
  const notify = useCallback<Notify>((message, severity = 'success') => {
    setState((s) => ({ open: true, message, severity, key: s.key + 1 }));
  }, []);
  return (
    <SnackbarContext.Provider value={notify}>
      {children}
      <Snackbar
        key={state.key}
        open={state.open}
        autoHideDuration={state.severity === 'error' ? 8000 : 4000}
        onClose={(_, reason) => reason !== 'clickaway' && setState((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ bottom: { xs: 'calc(80px + env(safe-area-inset-bottom))', md: 24 } }}
      >
        <Alert severity={state.severity} variant="filled" onClose={() => setState((s) => ({ ...s, open: false }))} sx={{ width: '100%' }}>
          {state.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
}

export const useSnackbar = () => useContext(SnackbarContext);
